// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"sz_a bhs_b bhs_bj","StrollerbaseBanner__hint":"sz_b bhs_vh","StrollerbaseBanner__link":"sz_c"};